import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  viewChild,
} from '@angular/core';

import { ConfirmationService as PrimengConfirmationService } from 'primeng/api';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { PrimengButtonDirective } from '../button/directives/primeng-button.directive';
import { ConfirmationService } from './services/confirmation.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-confirmation',
  imports: [ConfirmDialogModule, PrimengButtonDirective, Button],
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  providers: [PrimengConfirmationService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationComponent implements OnInit {
  private readonly confirmation = inject(ConfirmationService);
  private readonly primengConfirmation = inject(PrimengConfirmationService);

  protected acceptLabel = '';
  protected rejectLabel = '';

  protected readonly confirmDialog = viewChild.required(ConfirmDialog);

  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.listenToConfirmationShow();
  }

  protected accept(): void {
    const confirmDialog = this.confirmDialog();

    confirmDialog.onAccept();
  }

  protected reject(): void {
    const confirmDialog = this.confirmDialog();

    confirmDialog.onReject();
  }

  private listenToConfirmationShow(): void {
    this.confirmation.show$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (confirmation) => {
          const { acceptLabel, rejectLabel, accept, reject, title, message } =
            confirmation;

          this.acceptLabel = acceptLabel;
          this.rejectLabel = rejectLabel;

          this.primengConfirmation.confirm({
            header: title,
            message: message,
            accept: accept,
            reject: reject,
          });
        },
      });
  }
}
